import {
  Box,
  CircularProgress,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import { useCreateObjetivo } from "../../../../context/SuperAdmin/OASContexts/CreateObjetivoContext";

const ObjetivoForm = () => {
  const {
    niveles,
    nivelAsigns,
    tipos,
    nombre,
    codigo,
    selectedNivel,
    selectedNivelAsign,
    selectedTipo,
    handleNombreChange,
    handleCodigoChange,
    handleSelectNivel,
    handleSelectNivelAsign,
    handleSelectTipo,
    isLoadingNivelAsigns,
    isCreating,
  } = useCreateObjetivo();

  return (
    <Grid
      container
      direction="column"
      sx={{
        p: 2,
        borderRadius: 2,
        border: "1px solid #ccc",
        gap: 2,
        position: "relative",
      }}
    >
      <Grid item>
        <Typography variant="h6" fontWeight="bold">
          Detalles del objetivo
        </Typography>
      </Grid>

      {/* Overlay de cargando */}
      {isLoadingNivelAsigns && (
        <Box
          sx={{
            position: "absolute",
            inset: 0, // ocupa todo el Grid padre
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "rgba(255, 255, 255, 0.5)",
            zIndex: 10, // aseguro que esté por encima del contenido
          }}
        >
          <Grid container spacing={2} fontFamily={"Montserrat"}>
            <Grid item xs={12} sm={12} md={12} lg={12} sx={{ marginTop: "5%" }}>
              <Box display="flex" flexDirection="column" alignItems="center">
                <CircularProgress />
                <br />
                Cargando asignaturas...
              </Box>
            </Grid>
          </Grid>
        </Box>
      )}

      <Grid container spacing={3}>
        {/* Contenido (nombre) */}
        <Grid item xs={12}>
          <TextField
            label="Contenido"
            value={nombre}
            onChange={(e) => handleNombreChange(e.target.value)}
            multiline
            minRows={3}
            maxRows={8}
            fullWidth
            required
            disabled={isLoadingNivelAsigns || isCreating}
          />
        </Grid>

        {/* Código */}
        <Grid item xs={12} md={6}>
          <TextField
            label="Código"
            value={codigo}
            onChange={(e) => handleCodigoChange(e.target.value)}
            fullWidth
            required
            disabled={isLoadingNivelAsigns || isCreating}
          />
        </Grid>

        {/* Nivel */}
        <Grid item xs={12} md={6}>
          <FormControl
            fullWidth
            required
            disabled={isLoadingNivelAsigns || isCreating}
          >
            <InputLabel>Nivel</InputLabel>
            <Select
              value={selectedNivel}
              onChange={(e) => handleSelectNivel(e.target.value)}
              label="Nivel"
            >
              {niveles.map((nivel) => (
                <MenuItem key={nivel.id_nivel} value={nivel.id_nivel}>
                  {nivel.nombre}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>

        {/* Asignatura */}
        <Grid item xs={12} md={6}>
          <FormControl
            fullWidth
            required
            disabled={!selectedNivel || isLoadingNivelAsigns || isCreating}
          >
            <InputLabel>Asignatura</InputLabel>
            <Select
              value={selectedNivelAsign}
              onChange={(e) => handleSelectNivelAsign(e.target.value)}
              label="Asignatura"
            >
              {nivelAsigns.map((asignatura) => (
                <MenuItem
                  key={asignatura.id_nivel_asignatura}
                  value={asignatura.id_nivel_asignatura}
                >
                  {asignatura.asignatura}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>

        {/* Tipo */}
        <Grid item xs={12} md={6}>
          <FormControl
            fullWidth
            required
            disabled={isLoadingNivelAsigns || isCreating}
          >
            <InputLabel>Tipo</InputLabel>
            <Select
              value={selectedTipo}
              onChange={(e) => handleSelectTipo(e.target.value)}
              label="Tipo"
            >
              {tipos.map((tipo) => (
                <MenuItem key={tipo.id_tipo} value={tipo.id_tipo}>
                  {tipo.nombre}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default ObjetivoForm;
